import { useMatch } from 'react-router-dom';
import {
  ButtonGroup,
  Button,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
  cn
} from '@yakit/ui-components';

import { ChevronDown } from 'lucide-react';

import type { VDLLevel0Type } from '@VDL/types/VDLLevel0Type';

interface IVDLTableButton {
  code: VDLLevel0Type;
  label: string;
}

export type OnClickTableButton = (code: VDLLevel0Type) => void;

const VDL_TABLE_BUTTONS: IVDLTableButton[] = [
  { code: 'table', label: 'Таблица' },
  { code: 'graph', label: 'График' }
];

export const VDLTablesButtons = ({
  className,
  activeTableButtonCode,
  onClickTableButton
}: {
  className?: string;
  activeTableButtonCode?: string;
  onClickTableButton?: OnClickTableButton;
}) => {
  const match = useMatch('/:level0Code');

  const activeButton = VDL_TABLE_BUTTONS.find(
    (buttonObject) => buttonObject.code === activeTableButtonCode
  );

  const handleClickButton = (code: VDLLevel0Type) => {
    if (typeof onClickTableButton === 'function') onClickTableButton(code);
  };

  if (match) return;

  return (
    <>
      <ButtonGroup<IVDLTableButton>
        className={cn('hidden md:inline-flex', className)}
        listForButtons={VDL_TABLE_BUTTONS}
        renderButton={(buttonObject) => (
          <Button
            key={buttonObject.code}
            onClick={() => handleClickButton(buttonObject.code)}
            variant="outline"
            size="sm"
            className={cn({
              'border-primary bg-primary text-secondary hover:bg-primary/90 hover:text-accent':
                activeTableButtonCode === buttonObject.code
            })}
          >
            {buttonObject.label}
          </Button>
        )}
      />
      <DropdownMenu>
        <DropdownMenuTrigger className="md:hidden" asChild>
          <Button className={cn('group', className)} variant="outline">
            {activeButton?.label}
            <ChevronDown className="ml-2 h-4 w-4 group-data-[state=open]:rotate-180" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          {VDL_TABLE_BUTTONS.map((buttonObject) => (
            <DropdownMenuCheckboxItem
              key={buttonObject.code}
              checked={buttonObject.code === activeTableButtonCode}
              onCheckedChange={() => handleClickButton(buttonObject.code)}
            >
              {buttonObject.label}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
